import styled from 'styled-components'
import { colors, spacings } from 'styles/theme'

export const HeaderContainer = styled.header`
display: flex;
flex-direction: column;
justify-content: space-between;
top: 0px;
left: 88px;
width: calc(100% - 88px);
height: 115px;
overflow-x: hidden;
border-bottom: 1px solid ${colors.neutral_regular};
background: ${colors.white};

.header-text{
  display: flex;
  
  h1{
    padding-bottom: ${spacings.sl};
    display: inline;
    border-bottom: ${spacings.xs} solid ${colors.primary};
  }

  h2{
    /* margin-right: ${spacings.xs}; */
  }
}
`